import { TopMenu } from "./../layout/TopMenu.jsx";
import { LeftMenu } from "./LeftMenu.jsx";
import { useState } from "react";
const cx = require('classnames');

export const PrivateHome = ({children, user, subscriptionPackage, credits}) => {
    const username = user ? user.name : '';
    const [menuOpen, setMenuOpen] = useState(false);
    const handleMenuToggle = () => {
        setMenuOpen(!menuOpen);
    }
    const handleMenuclosed = () => {
        setMenuOpen(false);
    }
    return (
        <div className="min-h-screen w-full bg-[#f3f6f9] text-slate-950">
            <div className="min-h-screen w-full">
                <TopMenu username={username} credits={credits} subscriptionPackage={subscriptionPackage} onMenuToggle={handleMenuToggle}/>
                <div className="relative min-h-[calc(100vh-72px)] lg:grid lg:grid-cols-[280px_minmax(0,1fr)]">
                    {menuOpen && (
                        <button
                            className="fixed inset-0 z-20 bg-slate-950/40 lg:hidden"
                            aria-label="Close navigation"
                            onClick={handleMenuclosed}
                            type="button"
                        />
                    )}
                    <aside className={cx(
                        "fixed bottom-0 left-0 top-0 z-30 w-[280px] border-r border-slate-200 bg-white shadow-2xl transition-transform lg:sticky lg:top-[72px] lg:z-10 lg:h-[calc(100vh-72px)] lg:translate-x-0 lg:shadow-none",
                        menuOpen ? "translate-x-0" : "-translate-x-full"
                    )}> 
                        <LeftMenu onClick={handleMenuclosed}/>
                    </aside>
                    <main className="min-w-0 px-4 py-5 sm:px-6 lg:px-8">
                        {children}
                    </main>
                </div>
            </div>
        </div>
    );
}
